// extracted by mini-css-extract-plugin
module.exports = {"dividerMargin":"TeamDetail_dividerMargin__5aUdu"};